module.exports = __webpack_public_path__ + "img/share.1a31a88c.svg";